// src/rtkQuery/hooks/useQuestionnairesService.ts

import { useGetNewPatientQuestionnaireQuery, useLazyGetNewPatientQuestionnaireQuery } from "../services/questionnaires/questionnairesApi.slice";

export const useQuestionnairesService = () => {
    const {
        data,
        error,
        isLoading,
        isError,
        isSuccess,
        refetch,
        status,
    } = useGetNewPatientQuestionnaireQuery();

    const [
        trigger,
        {
            data: lazyData,
            error: lazyError,
            isLoading: lazyLoading,
            isSuccess: lazySuccess,
            isError: lazyFail,
            status: lazyStatus,
        },
    ] = useLazyGetNewPatientQuestionnaireQuery();

    const errorMessage = (error as any)?.meta?.error || (error as any)?.data?.message || 'Something went wrong';
    const lazyErrorMessage =
        (lazyError as any)?.meta?.error || (lazyError as any)?.data?.message || 'Something went wrong';

    return {
        questionnaireData: data,
        questionnaireIsLoading: isLoading,
        questionnaireIsError: isError,
        questionnaireIsSuccess: isSuccess,
        questionnaireError: error,
        questionnaireErrorMessage: errorMessage,
        questionnaireRefetch: refetch,
        questionnaireStatus: status,

        fetchQuestionnaire: trigger,
        questionnaireLazyData: lazyData,
        questionnaireLazyError: lazyError,
        questionnaireLazyIsLoading: lazyLoading,
        questionnaireLazyIsSuccess: lazySuccess,
        questionnaireLazyIsError: lazyFail,
        questionnaireLazyStatus: lazyStatus,
        questionnaireLazyErrorMessage: lazyErrorMessage,
    };

};
